// Shared skeleton loaders for tool-result cards. A tool emits a `{loading:true}`
// frame at call-start (see agent.py) and the timeline renders the matching
// skeleton here until the real result frame replaces it in place.

function CardSkeleton() {
  return (
    <div className="lk-card-skeleton" aria-hidden="true">
      <div className="lk-skeleton lk-card-skeleton-image" />
      <div className="lk-card-skeleton-body">
        <div className="lk-skeleton lk-skeleton-line" style={{ width: "40%", height: 9 }} />
        <div className="lk-skeleton lk-skeleton-line" style={{ width: "85%", height: 13 }} />
        <div className="lk-skeleton lk-skeleton-line" style={{ width: "55%", height: 11 }} />
        <div className="lk-card-skeleton-bottom">
          <div className="lk-skeleton lk-skeleton-line" style={{ width: 52, height: 14 }} />
          <div className="lk-skeleton lk-skeleton-line" style={{ width: 36, height: 12 }} />
        </div>
      </div>
    </div>
  );
}

// Tools whose results render as a horizontal row of cards (vs a single card).
const ROW_TOOLS = new Set([
  "search_products",
  "search_availability",
  "find_lesson_coaches",
  "find_tournaments",
]);

export function CardsSkeleton({ tool, count = 3 }: { tool: string; count?: number }) {
  if (ROW_TOOLS.has(tool)) {
    return (
      <div className="lk-card-skeleton-row" aria-hidden="true">
        {Array.from({ length: count }).map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    );
  }
  return <CardSkeleton />;
}
